<template>
    <div>
        <form data-vv-scope="Communicaton_settings">
        <!-- <pre> {{settings_data}}</pre>    -->
        <div style="height: 400px; overflow: auto;" class="vertical_scrollbar table-responsive">
          <table class="simple_table w-full">
            <thead>
              <tr>
                <td></td>
                <td>SMS</td>
                <td>EMAIL</td>
                <td>PUSH</td>
                <td>TEMPLATE</td>
              </tr>
            </thead>
            <tbody>
              <template v-for="(module, index1) in settings_data">
                <tr class="only_index_holder" :key="index1">
                  <td colspan="5">{{index1}}</td>
                </tr>
                <tr v-for="(module_data, index) in module" :key="index">
                  <td>{{module_data.entity_name}}</td>
                  <td class="flex">
                    <vs-checkbox v-model="module_data.setting.is_sms_active" v-if="module_data.action_name!='LeadActivity'"
                    @change="updateCommunicationSettings(settings_data)"></vs-checkbox>
                    <vs-checkbox disabled v-if="!module_data.setting.is_sms_active && module_data.action_name=='LeadActivity'"></vs-checkbox>
                  </td>
                  <td>
                    <vs-checkbox v-model="module_data.setting.is_email_active" v-if="module_data.action_name!='LeadActivity'" @change="updateCommunicationSettings(settings_data)"></vs-checkbox>
                    <vs-checkbox disabled v-if="!module_data.setting.is_email_active && module_data.action_name=='LeadActivity'"></vs-checkbox>
                  </td>
                  <td>
                    <vs-checkbox v-model="module_data.setting.is_push_active" @change="updateCommunicationSettings(settings_data)"></vs-checkbox>
                  </td>
                  <td>
                    <a style="cursor: pointer;" class="flex items-center" @click="templateModal(module_data.role_action_id,module_data.platform_module_id, module_data.entity_name,index1)">
                      <span style="font-size: 16px;" class="material-icons-outlined mr-1">add</span>Template
                    </a>
                    <!-- <a style="cursor: pointer;" class="flex items-center" @click="viewTemplate = true">
                      <span style="font-size: 16px;" class="material-icons-outlined mr-1">visibility</span>Template
                    </a> -->
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

            <!-- <div v-for="(module, index) in settings_data" :key="index" :open="index.toLowerCase() === tabToOpen">
                <div slot="header">
                    {{index}}
                </div>
                <ul class="comm-list">
                    <li class="my-2" v-for="(module_data, index) in module" :key="index">
                        <div class="flex justify-between items-center">
                            <p>{{module_data.entity_name}}</p>
                            <div class="flex">
                                <vs-checkbox v-model="module_data.setting.is_sms_active" v-if="module_data.action_name!='LeadActivity'"
                                @change="updateCommunicationSettings(settings_data)"
                                >SMS</vs-checkbox>
                                <vs-checkbox v-model="module_data.setting.is_email_active"  v-if="module_data.action_name!='LeadActivity'"
                                                                @change="updateCommunicationSettings(settings_data)"

                                >Email</vs-checkbox>
                                <vs-checkbox v-model="module_data.setting.is_push_active"
                                @change="updateCommunicationSettings(settings_data)"

                                >Push</vs-checkbox>
                            </div>
                        </div>
                        <vs-divider />
                    </li>
                </ul>
            </div>

            <vs-divider />

             <vs-button @click="updateCommunicationSettings(settings_data)" class="mt-4" type="filled" size="medium"
             v-if="settings_data"
             >Update Settings</vs-button> -->
        </form>
        <TemplateComponet v-if="viewTemplate" :module_name="module_name" :module_action_name="module_action_name" :role_action_id="role_action_id" :platform_module_id="platform_module_id" :viewTemplate="viewTemplate" @closeTemplate="closeTemplate"/>

    </div>
</template>

<script src="https://cdn.tiny.cloud/1/dby84f0rwttg363c3yyx0t5jucrrxd2rsclfsoi76uhjy4ez/tinymce/5/tinymce.min.js" referrerpolicy="origin"></script>

<script>
import { getCommunicationSettings, updateCommunicationSettings } from '@/api/communication'
import Editor from '@tinymce/tinymce-vue'

import TemplateComponet from './templateComponet.vue'

export default {
  name: 'Settings',
  components: {
    getCommunicationSettings,
    Editor,
    TemplateComponet
  },
  data:() => ({
    module_name:'',
    module_action_name:'',
    role_action_id:null,
    settings_data:[],
    settings_array:[],
    viewTemplate: false,
    initTinyMce: {
        setup: (editor) => {
          editor.ui.registry.addIcon(
            "filesIcon",
            '<svg class="primary_svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"/></svg>'
          );

          editor.ui.registry.addIcon(
            "gDriveIcon",
            '<svg class="font_18" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "></polyline><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "></polyline><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "></polyline></g></svg>'
          );

          editor.ui.registry.addButton('customInsertButton', {
            icon: 'filesIcon',
            tooltip: 'Insert Image from repo',
            onAction: () => {
              this.importModelRepo(editor)
            }
          })

          editor.ui.registry.addButton("gDrive", {
            icon: "gDriveIcon",
            tooltip: "Insert from GDrive",
            onAction: () => {
              this.gDrive(editor);
            },
          });
        },
        height: 500,
        menubar: true,
        branding: false,
        automatic_uploads: true,
        images_upload_credentials: true,
        plugins: [
          "autolink lists link image charmap print preview anchor",
          "imagetools",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste code help wordcount",
          "code lists fullscreen",
          "emoticons",
        ],
        menu: "table",
        toolbar:
          "customInsertButton gDrive insertfile image link |undo redo | formatselect | bold italic backcolor | \
                        table alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | help",
      }
  }),
  methods: {
    templateModal(role_action_id,platform_module_id, module_action_name, module_name) {
      this.viewTemplate = true
      this.role_action_id = role_action_id
      this.platform_module_id = platform_module_id
      this.module_action_name = module_action_name
      this.module_name = module_name
    },
    closeTemplate () {
      this.viewTemplate = false
      this.role_action_id = null
      this.platform_module_id = null
    },
    async updateCommunicationSettings (settings_data) {
      try {
        const settings_array = []

        Object.keys(settings_data).forEach(function (value) {
          settings_data[value].forEach(function (value2, key2) {
            settings_array.push(settings_data[value][key2].setting)
          })
        })

        const payload = {
          setting: settings_array
        }

        const customer_id = localStorage.getItem('customer_id')
        const data = await updateCommunicationSettings(customer_id, payload)

        this.$vs.notify({
          title: 'Success',
          text: 'Settings updated',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: 'Something Went Wrong',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
      }

    },
    async getCommunicationSettings () {
      try {
        this.$vs.loading()
        const customer_id = localStorage.getItem('customer_id')
        const data = await getCommunicationSettings(customer_id)
        //
        this.settings_data = data.data.data[0]
        //this.setCommunicationSettings()
      } catch (error) {
        console.warn(error)

      } finally {
        this.$vs.loading.close()
      }

    }
  },
  mounted () {
    this.getCommunicationSettings()
  },
  created () {
    //this.getCommunicationSettings()
    this.tabToOpen = this.$route.query.tab
  }
}
</script>

<style>
    .custom-collapse .vs-collapse-item {
        background: #fff;
        border-radius: 8px;
        border-top: 4px solid rgba(var(--vs-primary), 1);
        margin-bottom: 20px;
    }
    .vs-collapse-item--header {
        box-shadow: 0 4px 25px 0 rgba(0,0,0,.1);
        font-weight: bold;
    }
    .comm-list {
        list-style-type: none;
        margin: 0 16px;
    }
</style>